module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step3-FR.266068d8.png";